import React, { useEffect, useRef } from 'react'
import L from 'leaflet'

export const LeafletCustomPopup = ({ children, coordinates, map, onClose }) => {
  const popupRef = useRef()

  useEffect(() => {
    L.popup()
    .setLatLng(coordinates)
    .setContent(popupRef.current)
    .openOn(map)
    .on('remove', () => onClose())

  }, [children, coordinates, map])

  return (
    <div style={{ display: 'none' }}>
      <div ref={popupRef}>{children}</div>
    </div>
  )
}

export default LeafletCustomPopup